export function GtsRodo() {
  return (
    <div className="space-y-1 text-sm leading-tight">
      <h2 className="text-lg font-bold text-center mb-1">Klauzula RODO</h2>

      <div className="space-y-1">
        <div className="space-y-0.5">
          <p className="indent-2">
            1. Zgodnie z art. 13 ust. 1 rozporządzenia Parlamentu Europejskiego
            i Rady (UE) 2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób
            fizycznych w związku z przetwarzaniem danych osobowych i w sprawie
            swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE
            (ogólne rozporządzenie o ochronie danych) – dalej: RODO,
            informujemy, że administratorem Pani/Pana danych osobowych jest
            GRUPPO TRADE SERVICE-POLSKA sp. z o.o. z siedzibą w Warszawie, pl.
            Stanisława Małachowskiego 2, 00-066 Warszawa, będąca Zleceniodawcą
            usług.
          </p>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">2. Przetwarzane dane będą dotyczyć:</p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>Imię,</li>
            <li>Nazwisko,</li>
            <li>e-mail,</li>
            <li>telefon,</li>
            <li>PESEL,</li>
            <li>Adres zamieszkania,</li>
            <li>Płeć,</li>
            <li>Data urodzenia,</li>
            <li>Miejsce urodzenia,</li>
            <li>Numer rachunku bankowego,</li>
            <li>Urząd skarbowy,</li>
            <li>Obywatelstwo,</li>
            <li>
              Orzeczenie o niepełnosprawności, a jeżeli posiada takie
              orzeczenie, to stopień niepełnosprawności,
            </li>
            <li>
              Posiadanie statusu ucznia / studenta, a w przypadku posiadania
              takiego statusu:
              <ul className="list-disc list-inside ml-6 mt-0.5 space-y-0.5">
                <li>Nazwa szkoły / uczelni,</li>
                <li>Numer legitymacji szkolnej,</li>
                <li>Data ważności legitymacji,</li>
              </ul>
            </li>
            <li>
              Posiadanie aktywnej umowy o pracę na co najmniej wynagrodzenie
              minimalne, a w przypadku posiadania takiego statusu:
              <ul className="list-disc list-inside ml-6 mt-0.5 space-y-0.5">
                <li>Zakład pracy</li>
              </ul>
            </li>
            <li>
              Posiadanie statusu emeryta, a w przypadku posiadania takiego
              statusu:
              <ul className="list-disc list-inside ml-6 mt-0.5 space-y-0.5">
                <li>Nr świadczenia emerytalnego,</li>
                <li>Data od kiedy świadczenie emerytalne przysługuje,</li>
                <li>
                  Nazwa ZUS-u w którym świadczenie emerytalne zostało wydane,
                </li>
              </ul>
            </li>
            <li>
              Posiadanie statusu rencisty, a w przypadku posiadania takiego
              statusu:
              <ul className="list-disc list-inside ml-6 mt-0.5 space-y-0.5">
                <li>Nr świadczenia rentowego,</li>
                <li>Data od kiedy świadczenie rentowe przysługuje,</li>
                <li>Data do kiedy świadczenie rentowe przysługuje,</li>
                <li>
                  Nazwa ZUS-u w którym świadczenie rentowe zostało wydane,
                </li>
                <li>Rodzaj renty,</li>
              </ul>
            </li>
            <li>
              Posiadanie statusu obcokrajowca, a w przypadku posiadania takiego
              statusu:
              <ul className="list-disc list-inside ml-6 mt-0.5 space-y-0.5">
                <li>Numer paszportu,</li>
                <li>Posiadanie wizy (jeżeli dotyczy),</li>
                <li>Numer wizy (jeżeli dotyczy),</li>
                <li>Data ważności wizy (jeżeli dotyczy),</li>
                <li>Posiadanie Karty Polaka (jeżeli dotyczy),</li>
                <li>Data ważności Karty Polaka (jeżeli dotyczy),</li>
                <li>Posiadanie Karty Pobytu (jeżeli dotyczy),</li>
                <li>Data ważności Karty Pobytu (jeżeli dotyczy),</li>
              </ul>
            </li>
            <li>historia zatrudnienia i doświadczenie zawodowe,</li>
            <li>umiejętności i kwalifikacje zawodowe,</li>
            <li>wizerunek.</li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            3. Dane osobowe pozyskane w związku z zawarciem z Panią/Panem umowy
            będą przetwarzane w następujących celach:
          </p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>
              związanych z zawarciem oraz wykonaniem zawartej z Panią/Panem
              umowy, w tym w celu kontaktu przez Zleceniodawcę lub jego
              kontrahentów w celu weryfikacji wykonywania zlecenia,
              rozpatrywania skarg i reklamacji, uzyskiwania wyjaśnień,
              prowadzenia sporów dotyczących roszczeń Zleceniodawcy lub jego
              kontrahentów albo skierowanych przeciwko Zleceniodawcy lub jego
              kontrahentom,
            </li>
            <li>
              wypełniania obowiązków prawnych ciążących na Zleceniodawcy w
              związku z prowadzeniem działalności i realizacją zawartej z
              Panią/Panem umowy, w szczególności wynikających z przepisów
              podatkowych, rachunkowych oraz ubezpieczeń społecznych, a także –
              o ile ma zastosowanie – przepisów o przeciwdziałaniu praniu
              pieniędzy;
            </li>
            <li>
              ustalenia, dochodzenia lub obrony przed roszczeniami, prowadzenia
              postępowań sądowych i windykacyjnych oraz zapewnienia wewnętrznej
              administracji i bezpieczeństwa.
            </li>
            <li>udzielania odpowiedzi na Pani/Pana pisma, wnioski i skargi,</li>
            <li>
              dalszej rekrutacji do zawierania kolejnych umów zlecenia lub umów
              o podobnym charakterze,
            </li>
            <li>
              przekazywania Pani/Pana danych osobowych, pozyskanych w związku z
              zawarciem z Panią/Panem umowy innym podmiotom poszukującym
              pracowników / współpracowników / zleceniobiorców o Państwa
              kwalifikacjach,
            </li>
            <li>marketingowych, szkoleniowych i promocyjnych Zleceniodawcy</li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            4. Podstawą prawną przetwarzania Pani/Pana danych jest:
          </p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>
              niezbędność do wykonania umowy lub do podjęcia działań na
              Pani/Pana żądanie przed zawarciem umowy (art. 6 ust. 1 lit. b
              RODO),
            </li>
            <li>
              konieczność wypełnienia obowiązku prawnego ciążącego na
              administratorze (art. 6 ust. 1 lit. c RODO),
            </li>
            <li>
              niezbędność do celów wynikających z prawnie uzasadnionych
              interesów realizowanych przez administratora (art. 6 ust. 1 lit. f
              RODO),
            </li>
            <li>
              zgoda osoby uprawnionej na przetwarzanie jej danych osobowych w
              jednym lub większej liczbie określonych celów (art. 6 ust. 1 lit a
              RODO).
            </li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            5. Pozyskane od Pani/Pana dane osobowe mogą być przekazywane:
          </p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>podmiotom przetwarzającym je na nasze zlecenie,</li>
            <li>
              innym podmiotom gospodarczym poszukującym pracowników /
              współpracowników / zleceniobiorców do wykonywania prac o podobnym
              charakterze jak będące przedmiotem umowy zawartej ze
              Zleceniodawcą,
            </li>
            <li>
              organom lub podmiotom publicznym uprawnionym do uzyskania danych
              na podstawie obowiązujących przepisów prawa, np. sądom, organom
              ścigania lub instytucjom państwowym, gdy wystąpią z żądaniem, w
              oparciu o stosowną podstawę prawną,
            </li>
            <li>
              kontrahentom Zleceniodawcy (podmiotom na których rzecz
              Zleceniodawca wykonuje usługi) w celach weryfikacji wykonania
              usługi oraz sposobu jej wykonania, prowadzenia ewidencji osób
              wykonujących pracę na terenie jego placówek, przy czym zakres
              Państwa danych jakie mogą być przekazane to: imię, nazwisko, nr
              telefonu, adres email.
            </li>
            <li>
              podmiotom, u których wykonywane są usługi objęte zleceniem, w celu
              umożliwienia mu prowadzenia ewidencji osób wykonujących pracę na
              terenie jego placówek, przy czym zakres Państwa danych jakie mogą
              być przekazane to: imię, nazwisko, nr telefonu, adres email.
            </li>
          </ol>
        </div>

        <p className="indent-2">
          6. Pani/Pana dane nie będą przekazane do państw trzecich.
        </p>

        <div className="space-y-0.5">
          <p className="indent-2">
            7. Okres przetwarzania Pani/Pana danych osobowych jest uzależniony
            od celu w jakim dane są przetwarzane. Okres, przez który Pani/Pana
            dane osobowe będą przechowywane jest obliczany w oparciu o
            następujące kryteria:
          </p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>czasu obowiązywania umowy,</li>
            <li>
              przepisy prawa, które mogą nas obligować do przetwarzania danych
              przez określony czas,
            </li>
            <li>okres, który jest niezbędny do obrony naszych interesów,</li>
            <li>
              w przypadku danych objętych dobrowolną zgodą – bezterminowo do
              chwili cofnięcia zgody.
            </li>
          </ol>
        </div>

        <div className="space-y-0.5">
          <p className="indent-2">
            8. Ponadto, informujemy, że ma Pani/Pan prawo do:
          </p>
          <ol className="list-decimal list-inside space-y-0.5 ml-4">
            <li>dostępu do swoich danych osobowych,</li>
            <li>
              żądania sprostowania swoich danych osobowych, które są
              nieprawidłowe oraz uzupełnienia niekompletnych danych osobowych,
            </li>
            <li>
              żądania usunięcia swoich danych osobowych, w szczególności w
              przypadku cofnięcia przez Panią/Pana zgody na przetwarzanie, gdy
              nie ma innej podstawy prawnej przetwarzania,
            </li>
            <li>żądania ograniczenia przetwarzania swoich danych osobowych,</li>
            <li>
              wniesienia sprzeciwu wobec przetwarzania swoich danych, ze względu
              na Pani/Pana szczególną sytuację, w przypadkach, kiedy
              przetwarzamy Pani/Pana dane na podstawie naszego prawnie
              usprawiedliwionego interesu czy też na potrzeby marketingu
              bezpośredniego,
            </li>
            <li>przenoszenia swoich danych osobowych,</li>
            <li>
              wniesienia skargi do organu nadzorczego zajmującego się ochroną
              danych osobowych, tj. Prezesa Urzędu Ochrony Danych Osobowych.
            </li>
          </ol>
        </div>

        <p className="indent-2">
          9. W zakresie, w jakim Pani/Pana dane są przetwarzane na podstawie
          zgody – ma Pani/Pan prawo wycofania zgody na przetwarzanie danych w
          dowolnym momencie. Wycofanie zgody nie ma wpływu na zgodność z prawem
          przetwarzania, którego dokonano na podstawie Pani/Pana zgody przed jej
          wycofaniem. Zgodę może Pani/Pan wycofać poprzez wysłanie oświadczenia
          o wycofaniu zgody na nasz adres korespondencyjny bądź adres e-
          mailowy.
        </p>

        <p className="indent-2">
          10. Podanie danych zawartych w kwestionariuszu jest dobrowolne, jednak
          ich niepodanie spowoduje brak możliwości zawarcia z Państwem umowy, a
          cofnięcie zgody może spowodować niemożliwość realizacji zawartej już
          umowy.
        </p>

        <p className="indent-2">
          11. Informujemy, że nie korzystamy z systemów służących do
          zautomatyzowanego podejmowania decyzji.
        </p>

        <p className="indent-2">
          12. Nie przewiduje się przekazywania Pani/Pana danych osobowych poza
          obszar Europejskiego Obszaru Gospodarczego.
        </p>

        <div className="space-y-1 mt-2 p-4">
          <h3 className="text-base font-bold text-center">
            Oświadczenie o wyrażeniu zgody na przetwarzanie danych osobowych
          </h3>
          <p className="indent-2">
            Niniejszym wyrażam zgodę na przetwarzanie wszystkich moich danych
            osobowych wskazanych w pkt 2 powyższej klauzuli RODO zgodnie z
            treścią tej klauzuli.
          </p>
          <p className="indent-2 mt-2">
            Oświadczenie zaakceptowane elektronicznie
          </p>
        </div>
      </div>
    </div>
  );
}
